/**
 * Local-preview loader for /verhaalroute?source=local.
 *
 * Reads a frontend-safe copy of seed/story-route-seed.json bundled under src/
 * (CRA blocks imports outside src/, so this is a manually-synced copy).
 *
 * Produces the SAME nested shape as loadStoryRoute() in ./storyRoute.js:
 *   [{ id, sectionName, contentType, order, content, blocks: [{ id, blockType, order, isActive, content }] }]
 *
 * Semantics match the CMS read path:
 *   - Section.isActive === false  → hidden
 *   - ContentBlock.isActive === false → hidden (matches Codex fix in storyRoute.js)
 *   - The vacancy block stays active in seed; its content.vacancyIsActive
 *     drives the "no active vacancies" empty state (renderer concern).
 *
 * No AWS calls. No mutations. Safe to use without seed:live.
 */

import seed from "./storyRouteSeedSample.json";

function blockId(block) {
  return `local-block-${block._parentLocalId}-${block.blockType}-${block.order}`;
}

function sectionId(section) {
  return `local-${section._localId || section.sectionName}`;
}

export function getStoryRouteLocal() {
  const pageContents = Array.isArray(seed.pageContents) ? seed.pageContents : [];
  const contentBlocks = Array.isArray(seed.contentBlocks) ? seed.contentBlocks : [];

  const activeSections = pageContents.filter((s) => s.isActive !== false);

  const sections = activeSections.map((section) => {
    const blocks = contentBlocks
      .filter((b) => b._parentLocalId === section._localId)
      .filter((b) => b.isActive !== false)
      .map((b) => ({
        id: blockId(b),
        blockType: b.blockType,
        order: b.order ?? 0,
        isActive: true,
        content: b.content || {},
      }))
      .sort((a, b) => a.order - b.order);

    return {
      id: sectionId(section),
      sectionName: section.sectionName,
      contentType: section.contentType,
      order: section.order ?? 0,
      content: section.content || {},
      blocks,
    };
  });

  return sections.sort((a, b) => a.order - b.order);
}

export async function loadStoryRouteLocal() {
  return getStoryRouteLocal();
}
